// ============================================================================
// offlineSav.js — az "Offline – mentett tartalmat látsz" sáv (2026-10-23, docs/OFFLINE_TERV_2026-10-22.md, V1a).
//
// Kapcsolat nélkül, bekapcsolt offline-kezelővel (saját eszköz mód, bejelentkezett tag) a lap tetején sáv jelenik meg:
//  - "Offline – mentett tartalmat látsz.";
//  - "A szerveren legutóbb ellenőrizve: <idő>": a legutóbbi SZERVER által visszaigazolt pillanatkép ideje - NEM a tárból olvasott időbélyeg
//    (a titkár #65 kérése: a tár ideje ne látsszon friss ellenőrzésnek); ha még nem volt egyeztetés, ezt mondja ki;
//  - "a mentés pillanatában érvényes tartalom": a jogosultság-változások csak kapcsolattal érvényesülnek (nem ígérünk azonnali visszavonást).
// A sáv a #app ELŐTT áll (normál elemként, nem takar el semmit), és független a fő renderelési ciklustól.
// ============================================================================

import { t, localeFor } from "./i18n.js";

export function offlineSavInditasa({ kezelo, nyelv, ablak = window, dok = document }) {
  const sav = dok.createElement("div");
  sav.id = "offline-sav";
  sav.className = "offline-sav";
  sav.setAttribute("role", "status");
  sav.hidden = true;
  const app = dok.getElementById("app");
  if (app && app.parentNode) app.parentNode.insertBefore(sav, app);
  else dok.body.appendChild(sav);

  function frissit() {
    const a = kezelo.allapot();
    if (!a.offline) {
      if (!sav.hidden) sav.hidden = true;
      return;
    }
    const lang = nyelv();
    let ido = t(lang, "offline.neverChecked");
    if (typeof a.utolsoSzerverOk === "number") {
      let szoveg;
      try {
        szoveg = new Date(a.utolsoSzerverOk).toLocaleString(localeFor(lang), { dateStyle: "short", timeStyle: "short" });
      } catch (e) {
        szoveg = new Date(a.utolsoSzerverOk).toISOString();
      }
      ido = t(lang, "offline.lastChecked", { time: szoveg });
    }
    while (sav.firstChild) sav.removeChild(sav.firstChild);
    for (const [osztaly, szoveg] of [["offline-sav-cim", t(lang, "offline.banner")], ["offline-sav-ido", ido], ["offline-sav-megjegyzes", t(lang, "offline.savedNote")]]) {
      const p = dok.createElement("p");
      p.className = osztaly;
      p.textContent = szoveg;
      sav.appendChild(p);
    }
    sav.hidden = false;
  }

  kezelo.figyel(frissit);
  ablak.addEventListener("online", frissit);
  ablak.addEventListener("offline", frissit);
  frissit();
  return { frissit, elem: sav };
}
